import DefaultModal from '../../../../../../components/Modal/DefaultModal';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Row, Form, Col, Button, Input } from 'reactstrap';
import FlexSelect from '../../../../../../components/Inputs/FlexSelect';
import { ErrorMessage } from '@hookform/error-message';

const ModalLostReason = ({
  isModalOpen,
  onModalToggle,
  recordTypeId,
  listLostReason,
  changeOpportunityStage,
  updateLostReason,
  getOpportunityById,
  handleUpdateLostReason,
  isEdit,
  opportunity,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    getValues,
    formState: { errors }
  } = useForm();

  const [filterListLostReason, setFilterListLostReason] = useState([]);
  const maxChars = 100;

  const commentLostReason = watch('commentLostReason', '');

  useEffect(() => {
    if (!listLostReason) return;

    const options = listLostReason[0]?.options || [];
    const formattedOptions = options
      .filter((option) => option.recordTypeIds.includes(Number(recordTypeId)))
      .map((option) => ({ label: option.value, value: option.value }));

    setFilterListLostReason(formattedOptions);
  }, [listLostReason]);

  const onSubmit = async (data) => {
    try {
      if (!data.lostReason) {
        toast.error('Selecione um motivo de perda', {
          autoClose: 3000,
          closeOnClick: true
        });
        return;
      }
      updateLostReason = {
        ...updateLostReason,
        lostReason: data.lostReason,
        commentLostReason: data.commentLostReason || ''
      };
      if (isEdit) {
        await handleUpdateLostReason(updateLostReason);
        closeModal();
      } else {
        await changeOpportunityStage(updateLostReason);
        setTimeout(() => {
          getOpportunityById();
        }, 1000);
        closeModal();
      }
    } catch (err) {
      console.error(err);
      toast.error('Erro ao atualizar o protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Motivo de Perda"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Motivo de Perda*</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    isClearable={true}
                    placeholder="Selecione o motivo"
                    dataOptions={filterListLostReason || []}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    isDisabled={isEdit}
                    value={props.value}
                    valueController={setValue}
                    fieldName="lostReason"
                    labelName="value"
                    valueName="value"
                  />
                )}
                control={control}
                name="lostReason"
                rules={{
                  required: 'Campo obrigatório'
                }}
                defaultValue={opportunity?.lostReason || ''}
              />
              <ErrorMessage
                errors={errors}
                name="entity"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <label className="form-control-label">Comentário</label>
              <div style={{ position: 'relative' }}>
                <Controller
                  as={Input}
                  type="textarea"
                  rows="6"
                  control={control}
                  name="commentLostReason"
                  defaultValue={opportunity?.commentLostReason || ''}
                  maxLength={maxChars}
                />
                {getValues('commentLostReason') && (
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '8px',
                      right: '12px',
                      fontSize: '0.85rem',
                      color:
                        commentLostReason.length >= maxChars ? 'red' : '#666'
                    }}
                  >
                    {commentLostReason.length}/{maxChars}
                  </span>
                )}
              </div>
              <ErrorMessage
                errors={errors}
                name="commentLostReason"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};

export default ModalLostReason;
